// Frontend build marker. Updated at build time; git short SHA captured when authored.
// If a CI build injects REACT_APP_BUILD_ID, that wins at runtime.
export const BUILD_INFO = {
  build_sha: process.env.REACT_APP_BUILD_ID || 'c3f7033',
  app_version: '0.1.0',
  review_ui_copy_variant: 'generating-your-resume-v2', // current hardened ReviewStep copy
};
